import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import DatePicker from '../../DatePicker';
import { QueryOptions } from '../../Utils/QueryOptions';
import { FilterTypes } from '../Components';

class DateRangeFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inizio: null,
      fine: null,
    };

    this.inizioDateRange = createRef();
    this.fineDateRange = createRef();
  }

  handleInizioChange = (inizio) => {
    this.setState({
      inizio,
    }, this.check);
  };

  handleFineChange = (fine) => {
    this.setState({
      fine,
    }, this.check);
  };

  check = () => {
    const { fine, inizio } = this.state;
    if (inizio && fine) {
      this.notifica();
    }
  };

  notifica = () => {
    const { item } = this.props;
    const { inizio, fine } = this.state;

    // imposto l'ora di fine giornata alla data fine
    if (fine && fine instanceof Date) {
      fine.setHours(23, 59, 59);
    }

    this.notifyAddFilter(
      item.propertyName,
      QueryOptions.DATE_RANGE,
      null,
      null,
      {
        values: {
          inizio,
          fine,
        },
        sbiancaCampi: this.clearFields,
      },
      FilterTypes.DATERANGE,
      item.customFilter,
    );

    this.setState({
      inizio: null,
      fine: null,
    });
  };

  notifyAddFilter = (...filter) => {
    const { addFilter } = this.props;

    addFilter && addFilter(...filter);
  };

  clearFields = () => {
    this.inizioDateRange.clear();
    this.fineDateRange.clear();
  };

  render() {
    const {
      item,
      right,
    } = this.props;
    const {
      inizio,
      fine,
    } = this.state;

    return (
      <div className="filter__campoRicerca" style={item.width && { width: item.width.toString() }}>
        <div className="filter__dateRange">
          <DatePicker
            date={inizio}
            right={right}
            onChange={this.handleInizioChange}
            ref={(r) => { this.inizioDateRange = r; }}
            title={`${item.description || item.propertyName} da`}
            range={{ to: fine }}
          />
          <DatePicker
            date={fine}
            right={right}
            onChange={this.handleFineChange}
            ref={(r) => { this.fineDateRange = r; }}
            title={`${item.description || item.propertyName} a`}
            range={{ from: inizio }}
          />
        </div>
      </div>
    );
  }
}

DateRangeFilter.defaultProps = {
  right: false,
};

DateRangeFilter.propTypes = {
  /** Callback invocata all'aggiunta di un termine di filtro */
  addFilter: PropTypes.func.isRequired,
  /** Indica se aprire il menu nell'altro senso */
  right: PropTypes.bool,
  /** Descrittore del filtro da applicare */
  item: PropTypes.shape({
    propertyName: PropTypes.string.isRequired,
    description: PropTypes.string,
    customFilter: PropTypes.string,
    width: PropTypes.string,
  }).isRequired,
};

export default DateRangeFilter;
